import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "../src/styles/antd.overrides.less.css"
import { ConfigProvider } from "antd";
import ruRU from 'antd/locale/ru_RU';
import moment from 'moment';
import 'moment/locale/ru';

// Установка русской локали для moment
moment.locale('ru');

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ConfigProvider
    locale={ruRU}
    theme={{
      token: {
        colorPrimary: '#1890ff',
      },
    }}
  >
    <App />
  </ConfigProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
